import { FaCheck } from "react-icons/fa";
import { plans, personalizaciones, addOns} from '@/services/start/getPlants.js'
// Definición de los planes mensuales con todas las características detalladas


export default function SubscriptionPage() {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      {/* Sección de planes mensuales */}
      <div className="text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Planes Mensuales</h2>
        <p className="mt-4 text-xl text-gray-600">Selecciona el plan para tus necesidades</p>
      </div>

      <div className="mt-10 grid gap-8 lg:grid-cols-3 lg:gap-x-8">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className={`flex flex-col bg-white shadow-md rounded-lg p-6 ${
              plan.recommended ? "border-2 border-blue-500" : "border border-gray-200"
            }`}
          >
            {plan.recommended && (
              <div className="text-center -mt-2 mb-3">
                <span className="px-3 py-1 text-sm text-blue-600 bg-blue-100 rounded-full font-semibold">
                  Recomendado
                </span>
              </div>
            )}
            
            <div className="mb-4">
              <div className="text-center">
                <h3 className="text-2xl font-bold">Plan {plan.name}</h3>
                <p className="text-4xl font-extrabold mt-1">${plan.price} <span className="text-lg font-medium">/ mes</span></p>
                <p className="text-gray-600 mt-2">{plan.description}</p>
              </div>
            </div>
            
            <div className="mt-2 flex-grow">
              <ul className="space-y-3">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    {feature.included ? (
                      <FaCheck className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    ) : (
                      <div className="h-5 w-5 border border-gray-300 rounded-full mr-2 flex-shrink-0" />
                    )}
                    <span className={feature.included ? "text-gray-900" : "text-gray-500"}>{feature.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <button
              className={`mt-6 w-full py-2 rounded-md text-white font-semibold ${
                plan.recommended ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-600 hover:bg-gray-700"
              }`}
            >
              Elegir Plan {plan.name}
            </button>
          </div>
        ))}
      </div>

      {/* Sección de planes anuales */}
      <div className="mt-20 text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Planes Anuales</h2>
        <p className="mt-4 text-xl text-gray-600">Con descuento del 20%</p>
      </div>

      <div className="mt-10 grid gap-8 lg:grid-cols-3 lg:gap-x-8">
        {plans.map((plan) => (
          <div
            key={`${plan.name}-annual`}
            className={`flex flex-col bg-white shadow-md rounded-lg p-6 ${
              plan.recommended ? "border-2 border-blue-500" : "border border-gray-200"
            }`}
          >
            {plan.recommended && (
              <div className="text-center -mt-2 mb-3">
                <span className="px-3 py-1 text-sm text-blue-600 bg-blue-100 rounded-full font-semibold">
                  Recomendado
                </span>
              </div>
            )}
            
            <div className="mb-4">
              <div className="text-center">
                <h3 className="text-2xl font-bold">Plan {plan.name} Anual</h3>
                <p className="text-4xl font-extrabold mt-1">${plan.annual.price} <span className="text-lg font-medium">/ año</span></p>
                <p className="text-green-600 mt-1 font-medium">Ahorro del {plan.annual.saving}</p>
                <p className="text-gray-600 mt-2">{plan.description}</p>
              </div>
            </div>
            
            <div className="mt-2 flex-grow">
              <ul className="space-y-3">
                {plan.features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    {feature.included ? (
                      <FaCheck className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    ) : (
                      <div className="h-5 w-5 border border-gray-300 rounded-full mr-2 flex-shrink-0" />
                    )}
                    <span className={feature.included ? "text-gray-900" : "text-gray-500"}>{feature.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <button
              className={`mt-6 w-full py-2 rounded-md text-white font-semibold ${
                plan.recommended ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-600 hover:bg-gray-700"
              }`}
            >
              Elegir Plan Anual
            </button>
          </div>
        ))}
      </div>

      {/* Sección de Personalizaciones Adicionales */}
      <div className="mt-20 bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Personalizaciones Adicionales (Add-ons)</h2>
        <ul className="space-y-3">
          {personalizaciones.map((item, index) => (
            <li key={index} className="flex items-start">
              <FaCheck className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
              <span className="text-gray-700">{item.text}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Sección de Add-ons (Complementos) */}
      <div className="mt-20 text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">Complementos (Add-ons)</h2>
        <p className="mt-4 text-xl text-gray-600">Personaliza tu plan con complementos adicionales</p>
      </div>

      <div className="mt-10 space-y-8">
        {addOns.map((category) => (
          <div key={category.category} className="bg-white shadow-md rounded-lg p-6 border border-gray-200">
            <h3 className="text-xl font-bold mb-4 text-gray-900">{category.category}</h3>
            
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {category.options.map((option) => (
                <div key={option.name} className="border border-gray-200 rounded-lg p-4 flex flex-col">
                  <div className="flex-grow">
                    <h4 className="font-medium text-gray-900">{option.name}</h4>
                    <p className="mt-2 text-2xl font-bold">${option.price} <span className="text-sm font-normal text-gray-500">/ {option.period}</span></p>
                  </div>
                  <button className="mt-4 w-full py-2 px-4 bg-gray-800 hover:bg-gray-700 text-white rounded-md text-sm font-medium">
                    Agregar
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}